import React from 'react'
import { AuthorImage } from '../../../atoms'
import GuestAuthorTag from '../../../atoms/tags/guest-author'
import { removeWhitespaceAndSpecialChars } from '@h/commons'

interface IAboutAuthorDetails {
  imgUrl: string
  authorPageUrl: string
  name: string
  desc: string
  companyLogoUrl: string
}

export interface IAboutAuthorCardProps {
  name: string
  jsonBody: IAboutAuthorDetails
  showHeader: boolean
  companyLogoUrl: string
}

const SectionAuthor = ({ jsonBody, name, showHeader }: IAboutAuthorCardProps) => {
  try {
    return (
      <div className='section-author-module' id={removeWhitespaceAndSpecialChars(name)}>
        {showHeader && <h4 className='section-author-module__heading'>Section Author</h4>}
        <div className='section-author-module__container'>
          <div className='section-author-module__container__img-box'>
            <AuthorImage src={jsonBody.imgUrl} variant='large' />
            <div className='section-author-module__container__img-box__mobile'>
              <span className='section-author-module__container__img-box__mobile__name'>
                <a href={jsonBody.authorPageUrl}>{jsonBody.name}</a>
              </span>
              {jsonBody.companyLogoUrl && (
                <GuestAuthorTag companyLogoUrl={jsonBody.companyLogoUrl} />
              )}
            </div>
          </div>
          <div>
            <div className='section-author-module__container__img-box__desktop'>
              <span className='section-author-module__container__img-box__desktop__name'>
                <a href={jsonBody.authorPageUrl}>{jsonBody.name}</a>
              </span>
              {jsonBody.companyLogoUrl && (
                <GuestAuthorTag companyLogoUrl={jsonBody.companyLogoUrl} />
              )}
            </div>
            <div className='section-author-module__desc'>{jsonBody.desc}</div>
          </div>
        </div>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default SectionAuthor
